import axiosInstance from "../../../axiosInceptor";

export const applyRewardsByTokenAndVendorID = (basketID: string, body: any) => {
  try {
    const url = process.env.REACT_APP_OLO_API || '';
    return axiosInstance
      .put(url + `/baskets/${basketID}/loyaltyrewards/byref`, body)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  } catch (error) {
    throw error;
  }
};
